import { Image } from '@/atoms/Image'
import { useTranslate } from '@/utils/translate/translate-client'
import { DavidButton } from './DavidButton'

const imgImage02 = '/v1760542873/theatrical/david/david-sling-img-01'
const imgInspireGen = '/v1760914561/theatrical/david/dirt-texture-on-white-01'

export function SuperheroesSection() {
  const { t } = useTranslate('pif')
  return (
    <section
      className="relative w-full px-[16px] pb-[96px] pt-[72px] md:px-[64px] md:py-[160px]"
      data-name="superheros"
    >
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-[#faf0e7]" />
        <Image
          alt=""
          className="object-cover opacity-[0.55] mix-blend-color-burn"
          src={imgInspireGen}
          fill
          sizes="100vw"
          loading="lazy"
        />
      </div>
      <div
        className="relative mx-auto flex w-full max-w-[1440px] shrink-0 flex-col content-stretch items-center gap-[40px] text-clip md:flex-row md:gap-0"
        data-name="container-50-flip"
      >
        <div className="aspect-square h-[370px] w-[370px] shrink-0 overflow-hidden rounded-[16px] md:h-[692px] md:w-[692px] md:rounded-[24px]">
          <Image
            alt=""
            className="h-full w-full object-cover"
            src={imgImage02}
            width={892}
            height={892}
            sizes="(max-width: 768px) 370px, 892px"
          />
        </div>
        <div className="flex w-full shrink-0 flex-row items-center md:grow md:basis-0 md:self-stretch">
          <div className="relative h-full w-full shrink-0 md:min-h-px md:min-w-px md:grow md:basis-0">
            <div className="flex size-full flex-col justify-center">
              <div className="relative box-border flex size-full flex-col content-stretch items-start justify-center gap-[32px] p-0 md:gap-[40px] md:p-[64px]">
                <div className="relative flex w-full shrink-0 flex-col content-stretch items-start gap-[12px] not-italic">
                  <p className="font-angel-royal relative w-full shrink-0 text-[40px] lowercase not-italic leading-[40px] text-[#141447] md:text-[64px] md:leading-[64px]">
                    {t('davidSuperheroesTitle', "In a World of Superheroes, We're Telling the Story of a Real Hero")}
                  </p>
                  <p className="font-whitney-medium md:font-whitney-medium relative w-full shrink-0 text-[16px] not-italic leading-[24px] text-[#141447] md:text-[18px] md:leading-[28px]">
                    {t(
                      'davidSuperheroesDescription',
                      "Kids are flooded with stories of capes and gadgets. DAVID sparks their imagination with courage, faith, and the truth that with God, anything is possible. Imagine Halloween with slings and tunics instead of masks and capes—that's the power of a story told right.",
                    )}
                  </p>
                </div>
                <DavidButton variant="dark" openPifOverlay className="w-full md:w-auto">
                  {t('payItForward', 'Pay it Forward')}
                </DavidButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
